import Vue from 'vue'

export default new Vue({
    name: 'event-bus'
})



// WEBPACK FOOTER //
// ./src/components/layouts/bus.js